import axios from "axios";
import { toast } from "sonner";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const TOKEN_KEY = "jackstone_token";
const KIND_KEY = "jackstone_token_kind";

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On any 401 from a token-bearing call, drop the stale session and bounce to
// /login. Whitelist the auth endpoints — those naturally 401 on bad creds and
// each form already shows a friendly inline error.
const AUTH_PATHS = [
  "/auth/login",
  "/auth/register",
  "/employee-auth/login",
  "/employee-auth/change-pin",
];

api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const status = error?.response?.status;
    const tier = error?.response?.data?.tier;
    const url = (error?.config?.url || "").toString();
    const isAuthCall = AUTH_PATHS.some((p) => url.includes(p));
    // Tier-1 (company Google gate) missing/expired → back to the Google gate.
    if (status === 401 && tier === "company") {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(KIND_KEY);
      if (!window.location.pathname.startsWith("/auth/google")) {
        window.location.replace("/");
      }
      return Promise.reject(error);
    }
    if (status === 401 && !isAuthCall && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(KIND_KEY);
      try { toast.error("Session expired — please sign in again."); } catch (e) { console.warn("toast failed", e); }
      // Avoid redirect loop if we're already on /login.
      if (!window.location.pathname.startsWith("/login")) {
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
